<script lang="ts" setup>
import { defineModel, ref, onMounted, computed } from 'vue'

import { getLanguage } from '@/helpers/language-helper'
import { __ } from '@/utils/utils'

const activeLink = defineModel<{ link: String; title: String }>()

const links = [
  { link: 'hantecSocial', title: 'Hantec Social' },
  { link: 'hantecMobile', title: 'Hantec Mobile' },
  { link: 'hantecWebTrader', title: 'Hantec Web Trader' },
  { link: 'metatraderMobile', title: 'Metatrader Mobile' },
  { link: 'metatraderDesktop', title: 'Metatrader Desktop' },
  { link: 'clientPortal', title: 'Client Portal' }
]

const lang = ref<any>()

const getCookie = (name: string): string | null => {
  const value = `; ${document.cookie}`
  const parts = value.split(`; ${name}=`)
  if (parts.length === 2) return parts.pop()?.split(';').shift() || null
  return null
}

const country = computed(() => {
  return getCookie('country') || ''
})

onMounted(() => {
  lang.value = getLanguage()
})

const setActiveLink = (index: number) => {
  activeLink.value = links[index]
  showMenu()
}

const isMenuHidden = ref(true)

const showMenu = () => {
  isMenuHidden.value = !isMenuHidden.value
}
</script>
<template>
  <div class="text-lg font-bold leading-normal pb-[6px] text-center block lg:hidden">
    {{ __('Select a platform') }}
  </div>
  <div class="flex flex-col items-center lg:hidden">
    <div class="w-full px-[10px] flex justify-center">
      <div class="relative w-full">
        <button
          :class="isMenuHidden ? 'bg-red-150 text-white' : 'bg-gray-50 text-black'"
          class="flex justify-start w-full font-bold cursor-pointer rounded-[5px] text-xl leading-5 py-4"
          type="button"
          @click="showMenu()"
        >
          <div class="flex gap-[10px]">
            <div :class="activeLink?.link === 'hantecSocial' ? '' : ''" class="pl-[10px]">
              <div
                :class="activeLink?.link === 'hantecSocial' ? '' : 'hidden'"
                class="bg-white rounded-xl right-2 top-3"
              >
                <div
                  class="text-base font-normal text-black tracking-tightest px-[6px] py-[1px] leading-[19px] relative -top-[1px]"
                >
                  {{ country === 'KR' ? 'New' : __('New') }}
                </div>
              </div>
            </div>
            <div class="text-xl font-bold leading-6">{{ activeLink?.title }}</div>
          </div>
          <div class="absolute flex right-3 top-[24px]">
            <img v-if="isMenuHidden" loading="lazy" src="/assets/dropdown-arrow-down.webp" />
            <img v-if="!isMenuHidden" loading="lazy" src="/assets/dropdown-arrow-up-black.webp" />
          </div>
        </button>
        <div
          :class="{ hidden: isMenuHidden }"
          class="relative left-0 right-0 text-sm list-none bg-white divide-y divide-gray-100 shadow z-1"
        >
          <ul class="absolute w-full bg-white shadow-md">
            <li :class="activeLink?.link === 'hantecSocial' ? 'text-gray-500' : 'text-black'">
              <div class="flex items-center pt-[20px]">
                <div
                  :class="activeLink?.link === 'hantecSocial' ? 'grayscale' : ''"
                  class="ml-[20px]"
                >
                  <img loading="lazy" src="/assets/hantec-social.svg" />
                </div>
                <div class="w-full text-sm" role="menuitem" @click="setActiveLink(0)">
                  <div class="inline-flex items-center pl-[10px] text-base">
                    {{ __('Hantec Social') }}
                  </div>
                </div>
              </div>
            </li>
            <li :class="activeLink?.link === 'hantecMobile' ? 'text-gray-500' : 'text-black'">
              <div
                class="flex items-center w-full text-sm pt-[20px]"
                role="menuitem"
                @click="setActiveLink(1)"
              >
                <div
                  :class="activeLink?.link === 'hantecMobile' ? 'grayscale ' : ''"
                  class="ml-[20px]"
                >
                  <img loading="lazy" src="/assets/hantec-mobile.svg" />
                </div>
                <div class="inline-flex items-center pl-[10px] text-base">
                  {{ __('Hantec Mobile') }}
                </div>
              </div>
            </li>
            <li :class="activeLink?.link === 'hantecWebTrader' ? 'text-gray-500' : 'text-black'">
              <div
                class="flex items-center w-full text-sm pt-[20px]"
                role="menuitem"
                @click="setActiveLink(2)"
              >
                <div
                  :class="activeLink?.link === 'hantecWebTrader' ? 'grayscale ' : ''"
                  class="ml-[20px]"
                >
                  <img loading="lazy" src="/assets/hantec-mobile.svg" />
                </div>
                <div class="inline-flex items-center pl-[10px] text-base">
                  {{ __('Hantec Web Trader') }}
                </div>
              </div>
            </li>
            <li :class="activeLink?.link === 'metatraderMobile' ? 'text-gray-500' : 'text-black'">
              <div
                class="flex items-center w-full text-sm pt-[20px]"
                role="menuitem"
                @click="setActiveLink(3)"
              >
                <div
                  :class="activeLink?.link === 'metatraderMobile' ? 'grayscale' : ''"
                  class="ml-[20px]"
                >
                  <img loading="lazy" src="/assets/metatrader-mobile.svg" />
                </div>
                <div class="inline-flex items-center ] pl-[10px] text-base">
                  {{ __('Metatrader Mobile') }}
                </div>
              </div>
            </li>
            <li :class="activeLink?.link === 'metatraderDesktop' ? 'text-gray-500' : 'text-black'">
              <div
                class="flex items-center w-full text-sm pt-[20px]"
                role="menuitem"
                @click="setActiveLink(4)"
              >
                <div
                  :class="activeLink?.link === 'metatraderDesktop' ? 'grayscale' : ''"
                  class="ml-[20px]"
                >
                  <img loading="lazy" src="/assets/metatrader-desktop.svg" />
                </div>
                <div class="inline-flex items-center pl-[10px] text-base">
                  {{ __('Metatrader Desktop') }}
                </div>
              </div>
            </li>
            <li :class="activeLink?.link === 'clientPortal' ? 'text-gray-500' : 'text-black'">
              <div
                class="flex items-center w-full text-sm py-[20px]"
                role="menuitem"
                @click="setActiveLink(5)"
              >
                <div class="ml-[20px]">
                  <img
                    :class="activeLink?.link === 'clientPortal' ? 'grayscale' : ''"
                    loading="lazy"
                    src="/assets/client-portal.svg"
                  />
                </div>
                <div class="inline-flex items-center pl-[10px] text-base">
                  {{ __('Client Portal') }}
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
  <div class="flex justify-center w-full">
    <div
      class="mt-[80px] rounded-r-2.5 hidden lg:block relative sm:w-full lg:w-full 1440:w-full 1440:max-w-[1200px] lg:px-10 1440:px-0"
    >
      <ul
        class="flex 1440:text-xl font-bold bg-gray-50 max-w-300 rounded-r-2.5 rounded-l-2.5 z-50 left-0 right-0"
      >
        <li
          :class="activeLink?.link === 'hantecSocial' ? 'active' : ''"
          class="focus-within:z-10 rounded-l-2.5 cursor-pointer flex-1 relative"
          @click="setActiveLink(0)"
        >
          <div
            aria-current="page"
            class="h-19.5 flex justify-center items-center leading-5 1440:button lg:text-[16px]"
          >
            {{ __('Hantec Social') }}
          </div>
          <div
            v-if="activeLink?.link === 'hantecSocial'"
            class="absolute bg-white rounded-xl top-3"
            :class="lang === 'es' ? 'right-[1px]' : 'right-[11px]'"
          >
            <div
              class="1440:block hidden text-base font-normal text-black tracking-negative-tightest px-[6px] py-[1px] leading-normal relative -top-[1px]"
            >
              {{ country === 'KR' ? 'New' : __('New') }}
            </div>
          </div>
        </li>
        <li
          :class="activeLink?.link === 'hantecMobile' ? 'active' : ''"
          class="flex-1 cursor-pointer focus-within:z-10"
          @click="setActiveLink(1)"
        >
          <div class="h-19.5 flex justify-center items-center 1440:button lg:text-[16px]">
            {{ __('Hantec Mobile') }}
          </div>
        </li>
        <li
          :class="activeLink?.link === 'hantecWebTrader' ? 'active' : ''"
          class="flex-1 cursor-pointer focus-within:z-10"
          @click="setActiveLink(2)"
        >
          <div class="h-19.5 flex justify-center items-center 1440:button lg:text-[16px]">
            {{ __('Hantec Web Trader') }}
          </div>
        </li>
        <li
          :class="activeLink?.link === 'metatraderMobile' ? 'active' : ''"
          class="flex-1 cursor-pointer focus-within:z-10"
          @click="setActiveLink(3)"
        >
          <div class="h-19.5 flex justify-center items-center 1440:button lg:text-[16px]">
            {{ __('Metatrader Mobile') }}
          </div>
        </li>
        <li
          :class="activeLink?.link === 'metatraderDesktop' ? 'active' : ''"
          class="flex-1 cursor-pointer focus-within:z-10"
          @click="setActiveLink(4)"
        >
          <div class="h-19.5 flex justify-center items-center 1440:button lg:text-[16px]">
            {{ __('Metatrader Desktop') }}
          </div>
        </li>
        <li
          :class="activeLink?.link === 'clientPortal' ? 'active' : ''"
          class="flex-1 cursor-pointer rounded-r-2.5"
          @click="setActiveLink(5)"
        >
          <div
            class="h-19.5 flex justify-center items-center 1440:button lg:text-[16px] focus-within:z-10"
          >
            {{ __('Client Portal') }}
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<style scoped>
.active {
  background: red;
  color: white;
}
</style>
